import { render } from "./MrpTerms.vue?vue&type=template&id=8d74861a&ts=true"
import script from "./MrpTerms.vue?vue&type=script&lang=ts"
export * from "./MrpTerms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__